__turbopack_context__.v({
  "container": "Search-module-scss-module__-GV2YG__container",
});
